<template>
    <div class="row flex-grow">
        <div class="col-lg-7 mx-auto text-white">
            <div class="row align-items-center d-flex flex-row">
                <div class="col-lg-6 text-lg-right pr-lg-4">
                    <h1 class="display-1 mb-0">404</h1>
                </div>
                <div class="col-lg-6 error-page-divider text-lg-left pl-lg-4">
                    <h2>{{ $t('errors.404.sorry') }}</h2>
                    <h3 class="font-weight-light">{{ $t('errors.404.page_not_found') }}</h3>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 text-center mt-xl-2">
                    <router-link :to="{name: 'locker.get-aform'}" class="text-white font-weight-medium">
                        {{ $t('errors.404.back_to_home') }}
                    </router-link>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 mt-xl-2">
                    <p class="text-white font-weight-medium text-center">
                        Copyright &copy; {{ new Date().getFullYear() }}. All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "404"
}
</script>

<style scoped>

</style>
